<template>
  <!-- 发车信息 -->
  <div class="DepartureInformation_content">
    <div class="infoDiv">
      <div class="formbox">
        <!-- :rules="rulesBaseInform" -->
        <el-form
          :model="departForm"
          ref="departFormRef"
          label-width="100px"
          class="glo_formBox"
          :rules="rules"
        >
          <el-form-item label="发车批次" prop="dispatchNumber" required>
            <el-input
              v-model="departForm.dispatchNumber"
              placeholder="不填则保存后自动生成"
              clearable
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="派车类型" prop="dispatchType" required>
            <el-select
              filterable
              clearable
              v-model="departForm.dispatchType"
              placeholder="请选择"
              disabled
            >
              <el-option
                v-for="item in dispatchTypes"
                :key="item.state"
                :label="item.stateShow"
                :value="item.state"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出车时间" prop="planDepartureTime" required>
            <el-date-picker
              v-model="departForm.planDepartureTime"
              value-format="yyyy-MM-dd  HH:mm:ss"
              type="datetime"
              placeholder="请选择"
              disabled
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="始发网点:" prop="startDeptId" required>
            <el-select
              v-model="departForm.startDeptId"
              placeholder="请选择"
              clearable
              disabled
              filterable
            >
              <el-option
                v-for="item in businessDepts"
                :key="item.deptId"
                :label="item.deptName"
                :value="item.deptId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="queryItems" label="终端网点:">
            <el-select
              filterable
              clearable
              v-model="departForm.endDeptId"
              placeholder="请输入"
              disabled
            >
              <el-option
                v-for="item in businessDepts"
                :key="item.deptId"
                :label="item.deptName"
                :value="item.deptId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆类型" prop="carCategoryConfDictId" required>
            <el-select
              filterable
              clearable
              v-model="departForm.carCategoryConfDictId"
              placeholder="请选择"
              @change="changecarCategoryConfDictId"
              disabled
            >
              <el-option
                v-for="item in car_categoryList"
                :key="item.id"
                :label="item.val"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item required label="车牌号" prop="carNumber">
            <el-select
              filterable
              clearable
              allow-create
              remote
              v-model="departForm.carNumber"
              placeholder="请选择或输入"
              disabled
            >
              <el-option
                v-for="(item, index) in carNumberList"
                :key="index"
                :label="item.carNumber"
                :value="item.carNumber"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="driverOneName" label="司机姓名" required>
            <el-input
              v-model="departForm.driverOneName"
              placeholder="请输入"
              clearable
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="装货网点"
            required
            prop="deptId"
          >
            <el-select
              filterable
              clearable
              v-model="departForm.deptId"
              placeholder="请选择"
              :disabled="!canEdit"
            >
              <el-option
                v-for="item in businessDepts"
                :key="item.deptId"
                :label="item.deptName"
                :value="item.deptId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="装货时间" prop="operationTime" required>
            <el-date-picker
              v-model="departForm.operationTime"
              value-format="yyyy-MM-dd  HH:mm:ss"
              type="datetime"
              placeholder="请选择"
              :disabled="!canEdit"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            label="装货操作人"
            prop="operationUsers"
            class="operator-user-selector"
            required
          >
            <el-card shadow="never">
              <el-tag
                :key="index"
                v-for="(tag, index) in departForm.operationUsers"
                closable
                :disable-transitions="false"
                @close="handleClose(tag)"
                type="plain"
              >
                {{ tag }}
              </el-tag>
              <el-input
                class="input-new-tag"
                v-show="operatorNameInputVisible"
                v-model="operatorNameInput"
                ref="saveTagInput"
                size="small"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
                placeholder="请输入姓名"
                :style="
                  departForm.operationUsers.length === 0
                    ? 'margin-bottom:10px;'
                    : ''
                "
              >
              </el-input>
              <div>
                <el-button
                  class="button-new-tag"
                  size="small"
                  @click="showOperatorNameInput"
                  >手动录入</el-button
                >
                <el-button
                  class="button-new-tag"
                  size="small"
                  @click="showEmps = true"
                  >添加员工</el-button
                >
                <el-button
                  v-show="departForm.operationUsers.length > 0"
                  class="button-new-tag"
                  size="small"
                  @click="departForm.operationUsers = []"
                  >清空</el-button
                >
                <employee
                  :show.sync="showEmps"
                  :paramOne="paramOne"
                  @change="changeEmp"
                ></employee>
              </div>
            </el-card>
            <el-select
              v-show="false"
              filterable
              clearable
              v-model="departForm.operationUserId"
              placeholder="请选择"
              :disabled="!canEdit"
            >
              <el-option
                v-for="emp in emps"
                :key="emp.employeeId"
                :label="emp.jobNumber"
                :value="emp.employeeId"
              >
                <span style="float: left">{{ emp.jobNumber }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{
                  emp.employeeName
                }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import MyDialog from "@/components/Dialog.vue";
import Employee from "@/components/Employee.vue";
export default {
  components: {
    MyDialog,
    Employee,
  },
  props: {
    loadOrderId: {},
    dispatchId: {},
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      paramOne: {
        deptId: "",
      },
      departForm: {
        loadOrderId: "",
        dispatchId: "",
        dispatchNumber: "",
        dispatchType: "",
        planDepartureTime: "",
        startDeptId: "",
        endDeptId: "",
        carCategoryConfDictId: "",
        carNumber: "",
        driverOneId: "",
        driverOneName: "",
        deptId: "",
        operationUserId: "",
        operationUserName: "",
        operationTime: "",
        operationUsers: [],
      },
      dispatchTypes: [], // 派车类型
      businessDepts: [], // 网点
      car_categoryList: [], //车辆分类
      carNumberList: [], // 车牌号
      emps: [],
      rules: {
        deptId: [
          { required: true, message: "请选择装货网点", trigger: "blur" },
        ],
        driverOneName: [
          { required: true, message: "请填写司机姓名", trigger: "blur" },
        ],
        // operationUserId: [
        //   { required: true, message: "请选择装货操作人", trigger: "blur" },
        // ],
        operationTime: [
          { required: true, message: "请输入装货时间", trigger: "blur" },
        ],
        operationUsers: [
          {
            required: true,
            trigger: "change",
            message: "请选择装货操作人",
            validator: (rule, value, callback) => {
              if (!value || value.length == 0) {
                callback(new Error("请选择装货操作人"));
                return;
              }
              callback();
            },
          },
        ],
      },
      operatorNameInputVisible: false,
      operatorNameInput: "",
      isShowDialog: false,
      showEmps: false,
    };
  },
  watch: {
    loadOrderId: {
      handler(val) {},
    },
    dispatchId: {
      handler(val) {},
    },

    "departForm.deptId": {
      handler(val) {
        this.paramOne.deptId = val;
      },
    },
  },
  async mounted() {
    this.getDispatchTypes();
    this.getBusinessDepts();
    this.getConfDictValDownList("car_category", "car_categoryList");
    this.getEmps();
    await this.getLoadDetail();
    this.getDispatchInfo();
  },
  methods: {
    changeEmp(emps) {
      const operationUsers = this.departForm.operationUsers.concat(
        emps.map((item) => item.employeeName)
      );
      const uniqueArray = operationUsers.reduce((acc, cur) => {
        if (!acc.includes(cur)) {
          acc.push(cur);
        }
        return acc;
      }, []);
      this.departForm.operationUsers = uniqueArray;
    },
    async getDispatchInfo() {
      if (!this.dispatchId && !this.departForm.dispatchId) {
        return;
      }
      const detail = await this.$API.getDispatchUpdateDetail({
        dispatchId: this.dispatchId || this.departForm.dispatchId,
      });
      const result = detail.data.result;
      Object.assign(this.departForm, result);
      if (this.departForm.carCategoryConfDictId) {
        console.log(this.departForm.carCategoryConfDictId);
        this.departForm.carCategoryConfDictId = parseInt(
          this.departForm.carCategoryConfDictId
        );
      }
    },
    async getLoadDetail() {
      if (!this.loadOrderId) {
        return;
      }
      const res = await this.$API.runList({
        number: "admin_dispatch_load_detail_v5",
        loadOrderId: this.loadOrderId,
      });
      if (res && res.length > 0) {
        const item = res[0];
        Object.assign(this.departForm, item);
        if (item.operationUsers) {
          this.departForm.operationUsers = item.operationUsers.split(",");
        } else {
          this.departForm.operationUsers = [];
        }
      }
    },
    async getEmps() {
      const res = await this.$API.runList({
        number: "down_list_employee",
      });
      this.emps = res;
    },
    // 获取车辆下拉列表(拿车牌号码)
    async changecarCategoryConfDictId(e) {
      if (e) {
        const res = await this.$API.runList({
          number: "down_list_car",
          carCategoryConfDictId: e, //车辆分类id
        });
        this.carNumberList = res;
      }
    },
    // 根据字典类型获取字典值下拉列表 包装 车型 外发提货 外发送货方式
    async getConfDictValDownList(dictType, field) {
      const res = await this.$API.wtl_getConfDictValDownListV5(dictType);
      let arrs = res || [];
      // 其他情况
      this[field] = arrs;
    },
    // 获取营业网点
    async getBusinessDepts() {
      const data = await this.$API.runListReport({
        number: "business_dept_down_list",
      });
      this.businessDepts = data;
    },
    // 获取派车类型
    async getDispatchTypes() {
      const data = await this.$API.runListReport({
        number: "down_list_dispatch_type_v5",
      });
      this.dispatchTypes = data;
    },
    getForm() {
      return this.departForm;
    },
    async validate() {
      const valid = await this.$refs.departFormRef
        .validate()
        .then((res) => {
          return true;
        })
        .catch((err) => {
          return false;
        });
      return valid;
    },
    showOperatorNameInput() {
      this.operatorNameInputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleClose(tag) {
      this.departForm.operationUsers.splice(
        this.departForm.operationUsers.indexOf(tag),
        1
      );
    },
    handleInputConfirm() {
      let operatorNameInput = this.operatorNameInput;
      if (operatorNameInput) {
        this.departForm.operationUsers.push(operatorNameInput);
      }
      this.operatorNameInputVisible = false;
      this.operatorNameInput = "";
    },
    handleCloseDia() {
      this.isShowDialog = false;
    },
    diaConfirmBtn(formName) {
      const emps = this.$refs.emp.rows();
      this.departForm.operationUsers = this.departForm.operationUsers.concat(
        emps.map((item) => item.employeeName)
      );
      this.isShowDialog = false;
    },
  },
};
</script>

<style lang="less" scoped>
.DepartureInformation_content {
  .infoDiv {
    // border-width: 1px 1px 0 1px;
    // border-style: solid;
    // border-color: #f59a23;
    display: flex;
    .formbox {
      // padding: 0 30px;
      padding: 0 10px;
      // width: calc(100% - 70px);
      width: 100%;
      .glo_formBox {
        // justify-content: space-between;
        .el-form-item {
          margin-right: 1.8%;
        }
      }
    }
  }
}
.operator-user-selector {
  width: 100% !important;
  height: auto !important;
  /deep/ .el-form-item__label {
    margin-top: 10px;
  }
  /deep/ .el-form-item__content {
    height: auto;
  }
}
.el-card {
  border: none;
  /deep/ .el-card__body {
    padding: 10px !important;
  }
}

.el-tag {
  margin-right: 10px;
  margin-bottom: 10px;
}
.button-new-tag {
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 170px;
  border: 1px solid #dcdfe6;
}
</style>